<section class="forms flex column">
  @if (form.dirty && form.invalid) {
    <span color="alert-red">
      @if (form.hasError("max")) {
        {{
          "CASE_FORM.FORMS.CLAIMS.ERRORS.MAX_AMOUNT"
            | translate
              : {
                  max: form.errors?.max.max | number: "1.0" : "hu",
                  currency: "HUF",
                }
        }}
      }
    </span>
  }

  @for (claimForm of form.controls; track claimForm; let i = $index) {
    <app-claim-form
      [form]="claimForm"
      [index]="i"
    ></app-claim-form>
  }

  @if (isEditable()) {
    <button
      payee-button
      color="white"
      class="new-claim-button"
      (click)="addClaim()"
    >
      <div class="flex vcenter">
        <payee-icon name="plus-blue"></payee-icon>
        <span color="blue-king">{{ "CASE_FORM.FORMS.CLAIMS.ADD_CLAIM_BUTTON" | translate }}</span>
      </div>
    </button>
  }
</section>
